export const SET_MESSAGES = 'SET_MESSAGES'
export const SET_IS_RECEIVED_MESSAGE = 'SET_IS_RECEIVED_MESSAGE'
export const SET_IS_READ_MESSAGE = 'SET_IS_READ_MESSAGE'
export const SET_IMAGES_MESSAGE = 'SET_IMAGES_MESSAGE'
